var _defs, _path, _polygon, _rect, _polygon2, _path2, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 516.96 56.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.25,13.82c-2.54-4.23-6.1-7.52-10.68-9.88C34.99,1.59,29.69.41,23.69.41H0v56.22h23.69c6,0,11.3-1.18,15.88-3.53,4.58-2.36,8.14-5.65,10.68-9.88,2.54-4.23,3.8-9.13,3.8-14.7s-1.26-10.47-3.8-14.7ZM23.21,49.64h-15.18V7.4h15.18c4.66,0,8.7.88,12.1,2.65,3.4,1.77,6.02,4.23,7.9,7.39,1.87,3.16,2.81,6.85,2.81,11.08s-.94,7.87-2.81,11.06c-1.87,3.19-4.5,5.65-7.9,7.42-3.4,1.77-7.44,2.65-12.1,2.65Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.52 49.64 129.52 56.63 88.72 56.63 88.72 .41 128.4 .41 128.4 7.4 96.76 7.4 96.76 24.66 124.95 24.66 124.95 31.49 96.76 31.49 96.76 49.64 129.52 49.64"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 247.89,
    y: 0.41,
    width: 8.03,
    height: 56.22
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "341.01 49.64 341.01 56.63 300.21 56.63 300.21 .41 339.89 .41 339.89 7.4 308.25 7.4 308.25 24.66 336.44 24.66 336.44 31.49 308.25 31.49 308.25 49.64 341.01 49.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.52,37.81c.54-.19,1.04-.4,1.55-.62,3.48-1.55,6.16-3.78,8.03-6.69,1.87-2.92,2.81-6.43,2.81-10.5s-.94-7.58-2.81-10.52c-1.87-2.95-4.55-5.19-8.03-6.75-3.48-1.55-7.68-2.33-12.61-2.33h-21.93v56.22h8.03v-17.11h13.89c1.23,0,2.41-.05,3.56-.13h.03l12.07,17.24h8.75l-13.36-18.82ZM401.23,32.7h-13.65V7.4h13.65c5.14,0,9.05,1.1,11.7,3.29,2.65,2.2,3.96,5.3,3.96,9.32s-1.31,7.15-3.96,9.37c-2.65,2.22-6.56,3.32-11.7,3.32Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "491.42 .41 483.47 .41 458.01 56.63 466.28 56.63 487.41 8.57 508.53 56.63 516.96 56.63 491.42 .41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "217.38 .41 192.72 56.63 184.77 56.63 160.03 .41 168.71 .41 188.95 46.62 209.35 .41 217.38 .41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.21ebebeacd420d671a85066d13bbe11a.svg";
export { ForwardRef as ReactComponent };